<template lang="pug">
  InviteTeam(:groupID="$route.params.groupID" type="convidar")
</template>

<script>
  // Components
  import InviteTeam from './InviteTeam'

  export default {
    name: 'GroupInvite',

    components: {
      InviteTeam,
    },
  }
</script>
